module.exports = __webpack_public_path__ + "static/media/gladys3.64ccb736.mp3";